import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import PDFToPPTUploadView from "./PDFToPPTUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFToPPTMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To PPT Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_ppt", title: "Convert PDF To PPT Online" },
    data2: { link: "/pdf_to_ppt", title: "PDF To Powerpoint Presentation" },
    data3: { link: "/pdf_to_ppt", title: "PDF To Slides Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to PPT online instantly. Turn PDFs into editable PowerPoint slides quickly with our fast and secure PDF to PPT converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to ppt, pdf to powerpoint, convert pdf to ppt, pdf to ppt online, pdf to powerpoint online, pdf presentation converter, pdf slides converter, pdf to pptx, pdf to powerpoint converter, online pdf to ppt, editable powerpoint from pdf, pdf presentation tool, pdf conversion tool, pdf to slides, pdf editor online, pdf to pptx online, pdf to ppt converter online, online pdf to ppt converter free, free pdf converter, pptx converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToPPTUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to PPT online website is a powerful and user-friendly solution designed to convert PDF documents into fully editable PowerPoint presentations with accuracy and speed. This advanced PDF to PowerPoint converter online extracts text, images, charts, and layouts from PDF files and transforms them into PPT or PPTX slides while maintaining the original formatting as closely as possible. Whether you are a student preparing class presentations, a professional updating business reports, or a teacher reusing lecture materials, this convert PDF to PPT online tool simplifies your workflow and saves valuable time. With a clean and intuitive interface, users can upload PDF files and convert them to PowerPoint in just a few clicks—no technical skills or software installation required. Our PDF to PPT converter online works directly in your browser and supports high-quality output suitable for editing, presenting, and sharing. Strong security measures ensure your documents remain safe, with files processed securely and removed automatically after conversion. By turning static PDFs into editable PowerPoint slides, this tool enables easy content reuse, collaboration, and customization. If you’re searching for a fast, reliable, and accurate PDF to PowerPoint online converter that delivers professional results without compromising quality, this website is the ideal choice for modern document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To PPT Converter"
          why_use={[
            {
              title: "Convert PDFs into Editable Presentations",
              description:
                "Our PDF to PPT online converter allows you to transform static PDF files into fully editable PowerPoint presentations, making it easy to update content, change layouts, and reuse information efficiently.",
            },

            {
              title: "Save Time and Manual Effort",
              description:
                "Using a convert PDF to PPT online tool eliminates the need to manually recreate slides, helping users quickly convert PDF documents into PowerPoint format with minimal effort.",
            },

            {
              title: "Preserve Original Layout and Design",
              description:
                "This reliable PDF to PowerPoint converter online maintains fonts, images, tables, and slide structure, ensuring your converted PPT files retain a professional and consistent appearance.",
            },

            {
              title: "Boost Productivity and Workflow",
              description:
                "With a fast PDF to PPT online website, students, teachers, and professionals can convert files quickly, improving productivity and streamlining presentation creation.",
            },

            {
              title: "No Software Installation Required",
              description:
                "This browser based PDF to PPT converter online works without downloading or installing software, allowing users to convert PDF to PowerPoint instantly from any device.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PDF to PPT online tool is perfect for business reports, training materials, academic presentations, and lecture slides that require editing and customization.",
            },

            {
              title: "Easy Content Reuse and Collaboration",
              description:
                "Converting PDF to PPT online enables easy collaboration by allowing teams to share editable PowerPoint files instead of static PDFs.",
            },

            {
              title: "High Quality Presentation Output",
              description:
                "Our powerful PDF to PowerPoint online converter delivers high quality PPT slides suitable for meetings, conferences, and classroom presentations.",
            },

            {
              title: "Supports Complex and Text Based PDFs",
              description:
                "Our advanced PDF to PPT online converter can handle text-heavy documents and complex layouts, ensuring accurate and reliable PowerPoint conversions.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How do I convert PDF to PPT online?",
              description:
                "To convert PDF to PPT online, open the PDF to PPT tool on ShivaPDF.com, select your PDF file, start the conversion, and download the PowerPoint file when processing is complete. Review the slides to check the layout and content.",
            },
            {
              title: "Can I convert PDF to PowerPoint for free?",
              description:
                "An online PDF to PowerPoint converter can help you turn PDF documents into presentation files without installing desktop software. Check ShivaPDF's tool page for current free usage availability, file-size limits, and conversion restrictions.",
            },
            {
              title: "What is PDF to PPT conversion?",
              description:
                "PDF to PPT conversion transforms a PDF document into a PowerPoint presentation. It can make document content easier to organize into slides, present to an audience, and edit in compatible presentation software.",
            },
            {
              title: "Can I convert PDF to PPTX?",
              description:
                "Yes, a PDF converter that supports PPTX output can convert a PDF document into a PowerPoint presentation file. Check the available output formats on the conversion page before processing your document.",
            },
            {
              title: "What is the difference between PPT and PPTX?",
              description:
                "PPT is the older Microsoft PowerPoint presentation format, while PPTX is the newer Office Open XML format. PPTX is widely supported by modern presentation applications and is commonly used for new presentations.",
            },
            {
              title: "Can I edit slides after converting PDF to PowerPoint?",
              description:
                "You can edit the resulting presentation if the converter creates editable slide elements. Depending on the conversion method, some pages may instead appear as images, which limits editing individual text and graphic elements.",
            },
            {
              title: "Will PDF to PPT conversion preserve the original formatting?",
              description:
                "The converter attempts to preserve the original document's layout, text, images, and visual elements. However, fonts, spacing, tables, charts, and complex page designs may change during conversion, so review the slides afterward.",
            },
            {
              title: "Does each PDF page become a PowerPoint slide?",
              description:
                "Many PDF to PowerPoint converters create one slide for each PDF page, but the exact slide structure depends on the conversion tool. Check the resulting presentation to confirm that all pages and content are included.",
            },
            {
              title: "Can I convert a multi-page PDF to PowerPoint?",
              description:
                "Yes, a converter that supports multi-page documents can transform a PDF with multiple pages into a presentation containing corresponding slides. The maximum supported number of pages may depend on the tool's limits.",
            },
            {
              title: "Can I convert a scanned PDF to PPT?",
              description:
                "Scanned PDFs contain images of pages rather than directly accessible text. Converting them into editable PowerPoint content may require optical character recognition (OCR), and the result depends on the tool's OCR and layout-recognition capabilities.",
            },
            {
              title: "Can I convert a PDF with images and charts to PowerPoint?",
              description:
                "PDF to PowerPoint conversion can preserve or reproduce images, charts, and other visual elements. Whether these elements remain individually editable depends on the conversion method and the structure of the original PDF.",
            },
            {
              title: "Can I convert PDF to PPT without losing images?",
              description:
                "Images may be retained during conversion, but their quality, positioning, and size can vary. Review the generated presentation to make sure important images and visual elements appear correctly on every slide.",
            },
            {
              title: "Can I convert PDF to PowerPoint on Mac and Windows?",
              description:
                "A browser-based PDF to PowerPoint converter can be used on macOS and Windows through a supported web browser. You generally do not need to install a separate conversion application.",
            },
            {
              title: "Can I convert PDF to PPT on an iPhone or Android phone?",
              description:
                "You may be able to convert PDF files to PowerPoint using a mobile browser. The experience depends on the website's mobile compatibility, your device's memory, and the size of the PDF.",
            },
            {
              title: "Can I convert PDF to PPT without installing software?",
              description:
                "Yes, an online PDF to PPT converter lets you access the conversion process through a browser without installing dedicated desktop software, provided your device and browser are supported.",
            },
            {
              title: "Can I convert PDF to PPT offline?",
              description:
                "Offline conversion is possible when the required conversion engine and resources are available locally on your device. Many online PDF to PPT services require an internet connection, especially when files are processed on a remote server.",
            },
            {
              title: "Is it safe to convert PDF to PowerPoint online?",
              description:
                "Document privacy depends on how the conversion service handles uploaded files and generated presentations. Before converting confidential documents, review the website's privacy policy and check whether files are uploaded, stored, or processed locally.",
            },
            {
              title: "Can I convert a password-protected PDF to PPT?",
              description:
                "A password-protected PDF may need to be unlocked before conversion. Only process files you are authorized to access, and follow the converter's supported steps for protected documents.",
            },
            {
              title: "Why does my converted PowerPoint look different from the PDF?",
              description:
                "Differences can occur because PDF and PowerPoint use different page and slide layouts. Fonts, text positioning, image scaling, complex graphics, and unsupported elements can affect the result. Check the slides and adjust the formatting if needed.",
            },
            {
              title: "Can I convert PDF to PowerPoint for presentations?",
              description:
                "Yes, converting a PDF to PowerPoint can help you prepare document content for meetings, lectures, business presentations, and classroom use. Check whether the converted slides are editable enough for your intended presentation.",
            },
            {
              title: "Does converting PDF to PPT change the original file?",
              description:
                "PDF to PowerPoint conversion generally creates a separate presentation file and leaves the original PDF unchanged. Keep the original document if you need to compare the content or preserve its original layout.",
            },
            {
              title: "How do I convert a large PDF to PPT?",
              description:
                "Select your PDF in a converter that supports its file size and page count, then start the conversion. Large or image-heavy documents may take longer to process, so check the tool's file limits and review the resulting presentation.",
            },
            {
              title: "Can I convert PDF to PowerPoint while keeping text selectable?",
              description:
                "Selectable text depends on how the converter builds the slides. Some tools create editable text elements, while others place page content into images. Check the generated slides by selecting text to see whether it is editable.",
            },
            {
              title: "Why should I use ShivaPDF's PDF to PPT converter?",
              description:
                "A PDF to PPT converter can help you reuse PDF content in presentation slides for work, education, and meetings. Visit ShivaPDF's tool page to check its current output formats, conversion options, file limits, and privacy information.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToPPTMain;
